import useSWR from 'swr'
import { swrFetcher } from './helpers'
import { Response, SwrRecordHookParams } from './aboboApiTypes'
import { updateResponse } from './endpoints'

export const useResponse = ({
  id,
  swrOptions = {},
  fetcherOptions = {},
}: SwrRecordHookParams) => {
  const { data: response, error, mutate } = useSWR(id ? [`/responses/${id}`, fetcherOptions]: null, swrFetcher<Response>, swrOptions)

  return {
    response: response?.data,
    isLoading: !error && !response,
    isError: error,
    update: (updates) => mutate(updateResponse(id, updates, fetcherOptions.headers), {populateCache: false, revalidate: false})
  }
}

export const useResponses = ({fetcherOptions={}, swrOptions={}, delayLoading=false} = {}) => {
  const { data: responses, error, mutate } = useSWR(delayLoading ? null : [`/responses`, fetcherOptions], swrFetcher<Response[]>, swrOptions)

  return {
    responses: responses?.data,
    isLoading: !error && !responses,
    isError: error,
    update: (responseId, updates) => mutate(updateResponse(responseId, updates) as any, {populateCache: false}),
    mutate
  }
}